import { render, staticRenderFns } from "./213.vue?vue&type=template&id=24e7445e&scoped=true&"
var script = {}
import style0 from "./213.vue?vue&type=style&index=0&id=24e7445e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e7445e",
  null
  
)

export default component.exports